import { render, staticRenderFns } from "./MobilePushCard.vue?vue&type=template&id=13244f2c&"
import script from "./MobilePushCard.vue?vue&type=script&lang=js&"
export * from "./MobilePushCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports